@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

@icon-size: 24px;

.todo-list {
  max-width: 1000px;
  width: 100%;
}

.todo-list-header {
  margin-bottom: @space-16;
}

.todos {
  width: 100%;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  overflow: hidden;
}

.todo-list-item {
  display: flex;
  flex-direction: column;
  padding: @space-24;
  background-color: var(--white);
  border-bottom: 1px solid var(--gray-E4E5E7);

  &:last-child {
    border-bottom: none;
  }
}

/* Styling for checked todo items */
.marked-complete {
  .item-title,
  .item-description {
    color: var(--gray-8D9196);
  }
}

.item-header {
  align-items: center;
  width: 100%;
  margin-bottom: @space-12;
}

.check-button {
  position: relative;
  width: @icon-size;
  height: @icon-size;
  margin-right: @space-16;
  flex-shrink: 0;
}

.checkbox {
  width: @icon-size;
  height: @icon-size;
  border: 2px solid var(--gray-637381);
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.check-button-checked {
  border-color: var(--green-05b45e);
  background-color: var(--green-05b45e);
}

.check-icon {
  color: var(--white);
  width: 18px;
  height: 18px;
}

.item-title {
  font-weight: 600;
  flex-grow: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 50%;
}

.item-description {
  width: 100%;
  padding-left: @space-40;
  line-height: 24px;
}

.link {
  margin-left: auto;
  margin-right: @space-12;
}

.separator {
  width: 1px;
  height: 20px;
  background-color: var(--gray-E4E5E7);
  margin-right: @space-12;
}

.close-button {
  width: 12px;
}

.toggle-button-container {
  display: flex;
  justify-content: center;
  margin-top: @space-16;
}

.toggle-button {
  display: flex;
  align-items: center;
  gap: @space-8;
  padding: @space-8 @space-16;
  white-space: nowrap;
  flex-shrink: 0;
}

.toggle-icon {
  max-height: 16px;
  width: auto;
  flex-shrink: 0;
  display: inline-block;
}

@media @mobile {
  .todo-list {
    padding: 0 @space-16; // Match feature cards mobile padding
  }
}

@media @tablet {
  .todo-list {
    max-width: 600px; // Match feature cards tablet max-width
  }
}
